module.exports = __webpack_public_path__ + "static/media/0.b46ff352.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/home/case/cocina3/0.jpg
 ** module id = 616
 ** module chunks = 0
 **/